import requestv2 from "~/utils/http-v2";

const userApi = {
	info : async (params) => {
		const url = 'v2/user/info';
		return await requestv2.get(url, {params});
	},
	gets : async (params) => {
		const url = 'v2/user';
		return await requestv2.get(url, {params});
	},
	all : async (params) => {
		const url = 'v2/user/all';
		return await requestv2.get(url, {params});
	},
	search : async (params) => {
		const url = 'v2/user/search';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/user';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/user/${params.id}`;
		return await requestv2.patch(url, params);
	},
	block : async (id, params) => {
		const url = `v2/user/block/${id}`;
		return await requestv2.post(url, params);
	},
	locked : async (id) => {
		const url = `v2/user/locked/${id}`;
		return await requestv2.post(url);
	},
	unlocked : async (id) => {
		const url = `v2/user/un-locked/${id}`;
		return await requestv2.post(url);
	},
	changeRole : async (params) => {
		const url = `v2/user/role/${params.id}`;
		return await requestv2.post(url, params);
	},
	groupSwitch : async (params) => {
		const url = `v2/user/group/${params.id}`;
		return await requestv2.post(url, params);
	},
	pay : async (params) => {
		const url = `v2/user/pay/${params.id}`;
		return await requestv2.post(url, params);
	},
	leader : async (params) => {
		const url = `v2/user/leader/${params.id}`;
		return await requestv2.post(url, params);
	},
	password : async (params) => {
		const url = `v2/user/password/${params.id}`;
		return await requestv2.post(url, params);
	},
	history : async (id) => {
		const url = `v2/user/history/${id}`;
		return await requestv2.get(url);
	},
};

export default userApi;